import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { ImageListItem } from "@material-ui/core";
import { ImageWrapper } from "./imageWrapper";
var useStyles = makeStyles(function () {
    return createStyles({
        container: {
            width: "99%",
        },
    });
});
export var Banner = function (_a) {
    var banner = _a.banner, imageWrapper = _a.imageWrapper;
    var bannerUrl = banner.bannerUrl, serviceMessageId = banner.serviceMessageId, link = banner.link, altText = banner.altText;
    var styles = useStyles();
    var article = {
        fullSizeImageUrl: bannerUrl,
        serviceMessageId: serviceMessageId,
        link: link,
        altText: altText,
        mediaType: "image",
    };
    return (React.createElement(ImageListItem, { className: styles.container, key: banner.serviceMessageId },
        React.createElement(ImageWrapper, { wrapperFunc: imageWrapper, article: article, dataTestId: "lib-banner" })));
};
